<button *ngIf="view === 'button'" mat-raised-button color="primary" (click)="goto()">{{title}}</button>
<span *ngIf="view === 'icon'" class="material-icons" (click)="goto()">keyboard_arrow_right</span>
